import { Button, ButtonsContainer, Modal } from '@forma/forma-ui-kit';
import ClientWrap from '@/components/ClientWrap';
import styles from './block-template.module.css';
import { ThemeContext } from '@forma/forma-ui-kit';
import { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Trans, useTranslation } from 'next-i18next';
import { ReactSVG } from 'react-svg';
import { analytics } from '@/helpers/analytics';

const BlockTemplate = ({ previews, template }) => {
  const [isOpenModal, setOpenModal] = useState(false);
  const { viewport } = useContext(ThemeContext);
  const isPhone = viewport === 'phone';
  const { t } = useTranslation();

  const [imagesStateLoad, setImagesStateLoad] = useState(
    !!previews.length ? previews.reduce((acc, image) => ({ ...acc, [image.id]: false }), {}) : {}
  );

  const handleChangeStateLoad = (imageID) => {
    setImagesStateLoad((state) => ({ ...state, [imageID]: true }));
  };

  useEffect(() => {
    if (isOpenModal) return;
    !!previews.length &&
      setImagesStateLoad(
        previews.reduce((acc, image) => {
          return { ...acc, [image.id]: false };
        }, {})
      );
  }, [isOpenModal, previews]);

  const scrollToBlockFunction = (idElement) => {
    const element = document.getElementById(idElement);
    if (!element) return;
    const elementPosition =
      element.getBoundingClientRect().top + window.scrollY - 70;
    window.scrollTo({ top: elementPosition, behavior: 'smooth' });
  };

  const handleClickFill = () => {
    scrollToBlockFunction('fill-document');
    analytics.clickFillTemplate();
  };

  const handleClickFillTemplatePopup = () => {
    setOpenModal(false);
    document.body.style.overflow = 'auto';
    setTimeout(() => {
      handleClickFill();
    }, 200);
  };

  const handleClickExample = () => {
    setOpenModal(true);
    analytics.clickShowExample();
  };

  return (
    <>
      <div className={styles.root}>
        <div className={styles.leftBlock}>
          <h2 className={styles.title}>
            <Trans
              i18nKey="seo_h2_template"
              components={{ accent: <span className="accent-text" />, underline: <span className={styles.underline} /> }}
              values={{ title: template.seoName ? template.seoName : template.name }}
            />
          </h2>
          {template.seo && (
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{ __html: template.seo }}
            ></div>
          )}
          {!isPhone && (
            <ButtonsContainer className={styles.buttons}>
              <Button onClick={handleClickFill}>
                {t('fill_template_online')}
              </Button>
              <div className={styles.buttonNotice}>
                <Trans i18nKey="faster_than_word" components={{ accent: <span className={styles.accentBlue} /> }} />
                <ReactSVG src="/icons/fire-color.svg" wrapper="span" />
              </div>
            </ButtonsContainer>
          )}
        </div>
        <div className={styles.rightBlock}>
          <div className={styles.imageWrapper}>
            <img
              src={
                previews.length > 0 ? previews[0].url : '/images/seo/nofoto.svg'
              }
              alt=""
            />
            {previews.length > 0 && (
              <div className={styles.imageOverlay}>
                <Button
                  className={styles.buttonInnerImg}
                  viewStyle="tertiary"
                  onClick={handleClickExample}
                >
                  {t('see_example')}
                </Button>
              </div>
            )}
          </div>
          <div className={styles.imageDesctiptionText}>
            {t('example_filled_template')}
          </div>
        </div>
        {isPhone && (
          <ButtonsContainer className={styles.buttons}>
            <Button onClick={handleClickFill} fullWidth>
              {t('fill_template_online')}
            </Button>
            <div className={styles.buttonNotice}>
              <Trans i18nKey="faster_than_word" components={{ accent: <span className={styles.accentBlue} /> }} />
              <ReactSVG src="/icons/fire-color.svg" wrapper="span" />
            </div>
          </ButtonsContainer>
        )}
      </div>
      {isOpenModal && (
        <ClientWrap>
          <Modal
            open={isOpenModal}
            buttons={isPhone && [
              {
                children: t('fill_template_online'),
                onClick: handleClickFillTemplatePopup
              }
            ]}
            onClose={setOpenModal}
            size="extraLarge"
            title={
              <div className={styles.blockPopupText}>
                <div>{template.name}</div>
                {!isPhone && <Button size="medium" onClick={handleClickFillTemplatePopup}>{t('fill_template_online')}</Button>}
              </div>
            }
            showClose
          >
            {previews.map((image) => (
              <div key={image.id} className={styles.galeryWrapperImg}>
                {!imagesStateLoad[image.id] && (
                  <div
                    className={classNames(
                      styles.galeryWrapperImg,
                      'skeleton-loading'
                    )}
                  ></div>
                )}
                <img
                  src={image.url}
                  className={!imagesStateLoad[image.id] ? styles.hidden : ''}
                  onLoad={() => handleChangeStateLoad(image.id)}
                  alt={template.name}
                ></img>
              </div>
            ))}
          </Modal>
        </ClientWrap>
      )}
    </>
  );
};

export default BlockTemplate;
